<div class="container">
  <div class="title-wrap">
    <p class="title">Vas a retirar estas inversiones</p>
  </div>

  <div class="field-row field-row--payer-and-amount u-pb-4">
    <div class="field-group field-group--payer">
      <p class="field-label">Empresa pagadora</p>
      <p class="field-value field-value--payer-company">
        {{ (data?.invoice?.debtor?.companyName || '-') | uppercase }}
      </p>
    </div>
    <div class="field-group field-group--amount">
      <p class="field-label">Monto adelantado</p>
      <ng-container
        *ngIf="data?.invoice?.advanceAmount != null && data?.invoice?.advanceAmount !== ''; else advanceAmountMissing"
      >
        <p class="field-value field-value--money">
          {{ data?.invoice?.currency | currencyToSign }}&nbsp;{{
            data?.invoice?.advanceAmount | numberSpacing
          }}
        </p>
      </ng-container>
      <ng-template #advanceAmountMissing>
        <p class="field-value field-value--money">-</p>
      </ng-template>
    </div>
  </div>

  <div class="field-row">
    <div class="field-group field-group--summary">
      <div class="available-summary">
        <p class="field-label">Monto disponible para invertir</p>
        <p class="available-summary__value">
          {{ data?.invoice?.currency | currencyToSign }}&nbsp;{{
            data?.availableToInvestAmount | numberSpacing
          }}
        </p>
      </div>
    </div>
  </div>

  <div class="field-row investors-section" *ngIf="data?.selectedInvestments?.length">
    <div class="field-group field-group--block">
      <div class="code-table-wrap">
        <div
          class="code-table"
          [ngClass]="data.selectedInvestments.length > 1 ? 'small-height' : 'big-height'"
        >
        <table>
          <tr>
            <th>
              <div class="th-investor">
                <span class="th-investor__text">Inversionista</span>
              </div>
            </th>
            <th class="col-amount">Monto</th>
          </tr>
          <tr *ngFor="let investment of data.selectedInvestments">
            <td>{{ getInvestorName(investment) || '-' }}</td>
            <td class="td-amount">
              {{ data?.invoice?.currency | currencyToSign }}&nbsp;{{
                getInvestmentAmount(investment) | numberSpacing
              }}
            </td>
          </tr>
        </table>
        </div>
      </div>
    </div>
  </div>
</div>
